const env = {
  // baseUrl: 'http://ec2-3-142-92-25.us-east-2.compute.amazonaws.com/backend/'
  // baseUrl: "http://192.168.18.106:1337/backend/",
  baseUrl: "https://utirx.com/backend/",
};

export default env;
